import { useEffect, type ReactNode } from 'react'
import { tokenStore } from '@/api'
import { getSyncEngine } from './engine'
import { startDraftBackup } from '@/features/gate/data/draftBackup'

/**
 * Starts the app-wide sync engine. Mounted inside the phone surface only — the console is online
 * and has no outbox.
 */
export function SyncProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const engine = getSyncEngine()
    // A sign-in on this phone (e.g. from the Sync screen) releases waiting work at once.
    const offTokens = tokenStore.subscribe((t) => t && void engine.syncNow())
    let stop: (() => void) | undefined
    let cancelled = false
    // Open farmers' backups to the server: beside the sync engine, never part of it.
    let stopBackup: (() => void) | undefined
    try {
      stopBackup = startDraftBackup()
    } catch {
      /* a backup problem never stops the phone */
    }
    void engine.start().then((s) => {
      if (cancelled) s()
      else stop = s
    })
    return () => {
      cancelled = true
      offTokens()
      stop?.()
      stopBackup?.()
    }
  }, [])
  return <>{children}</>
}
